<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M33.5 33.68V13a1.5 1.5 0 00-3 0v20.68a6.49 6.49 0 000 12.64V51a1.5 1.5 0 003 0v-4.68a6.49 6.49 0 000-12.64zM32 43.5a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zM14.5 17.68V13a1.5 1.5 0 00-3 0v4.68a6.49 6.49 0 000 12.64V51a1.5 1.5 0 003 0V30.32a6.49 6.49 0 000-12.64zM13 27.5a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5zM57.5 32a6.51 6.51 0 00-5-6.32V13a1.5 1.5 0 00-3 0v12.68a6.49 6.49 0 000 12.64V51a1.5 1.5 0 003 0V38.32a6.51 6.51 0 005-6.32zM51 35.5a3.5 3.5 0 113.5-3.5 3.5 3.5 0 01-3.5 3.5z"/></svg>